
<!-- DESKTOP VERSION -->

<div class="transfer-table-wrapper display-desktop">
  <table class="transfer-table">
    <thead>
      <tr>
        @if (isAnswered) {
          <th>Seleccionar</th>
        }
        <th>Producto</th>
        <th>{{ isAnswered ? 'Ofrecida/Requerida' : 'Requerida' }}</th>
        @if (isAnswered) {
          <th>Seleccionada</th>
          <th>Precio Unitario Ofrecido</th>
          <th>Total</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (inventory_action_product of inventoryActionForPricing().inventory_action_products; track inventory_action_product.id) {
        <tr>
          @if (isAnswered) {
            <td>
              <mat-checkbox
                [ngModel]="getSelectedProduct(inventory_action_product.product_id)?.quantity"
                (ngModelChange)="toggleSelectedProduct(inventory_action_product, $event)"
                [disabled]="!isAnswered || isFinished"
              ></mat-checkbox>
            </td>
          }
          <td>
            <div>
              <div class="name">{{inventory_action_product.product.name}}</div>
              <div class="code">{{inventory_action_product.product.code}}</div>
            </div>
          </td>
          <td>
            @if (isAnswered) {
              {{inventory_action_product.quantity}}
              de {{ getRequiredProduct(inventory_action_product.product_id)?.quantity }} unidades
            } @else {
              {{getRequiredProduct(inventory_action_product.product_id)?.quantity}} unidades
            }  
          </td>
          @if (isAnswered) {
            <td>
              <input 
                type="number"
                [ngModel]="getSelectedProduct(inventory_action_product.product_id)?.quantity"
                (ngModelChange)="updateSelectedProductQuantity(inventory_action_product, $event)"
                [disabled]="isFinished || !inventory_action_product.extra_params.flexible"
                [min]="0"
                [max]="inventory_action_product.quantity"
              >
            </td>
            <td>
              {{inventory_action_product.amount | money}}
            </td>
            <td>
              {{inventory_action_product.amount * getSelectedProduct(inventory_action_product.product_id)?.quantity | money}}
            </td>
          }
        </tr>
      }
      @if (isAnswered) {
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>IVA:</td>
          <td>{{ IVA | money }}
          </td>
        </tr>
        <tr class="last_row">
          <td></td>
          <td></td>
          <td></td>
          <td class="total_column">Total:</td>
          <td class="total_column">{{ Total | money }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<!-- MOBILE VERSION -->
<div class="products display-mobile">
  @for (inventory_action_product of inventoryActionForPricing().inventory_action_products; ; track inventory_action_product.id) {
    <div class="item">
      @if (isAnswered) {
        <mat-checkbox
          [ngModel]="getSelectedProduct(inventory_action_product.product_id)?.quantity"
          (ngModelChange)="toggleSelectedProduct(inventory_action_product, $event)"
          [disabled]="!isAnswered || isFinished"
        ></mat-checkbox>
      }
      <div class="card product">
        <div class="card-content">
          <div class="card-details">
            <div class="row title">
              <span class="bold">{{inventory_action_product.product.name}}</span>
              <span class="light">#{{inventory_action_product.product.code }}</span>
            </div>
            <div class="row">
              <span>
                @if (isAnswered) {
                  Cantidad Ofrecida/Requerida: 
                  {{inventory_action_product.quantity}} / {{ getRequiredProduct(inventory_action_product.product_id)?.quantity }} {{ inventory_action_product.unit | titlecase}}
                } @else {
                  {{ getRequiredProduct(inventory_action_product.product_id)?.quantity }} {{ inventory_action_product.unit | titlecase}} Requerida
                }  
              </span>
            </div>
            @if (isAnswered) {
              <div class="row quantity-input">
                <span>
                  Cantidad seleccionada:
                </span>
                <span>
                  <input 
                    type="number"
                    [ngModel]="getSelectedProduct(inventory_action_product.product_id)?.quantity"
                    (ngModelChange)="updateSelectedProductQuantity(inventory_action_product, $event)"
                    [disabled]="isFinished || !inventory_action_product.extra_params.flexible"
                    [min]="0"
                    [max]="inventory_action_product.quantity"
                  >
                </span>
              </div>
              <div class="row">
                <span>
                  Precio Unitario Ofrecido:
                </span>
                <span class="light">
                  {{inventory_action_product.amount | money}}
                </span>
              </div>
              <div class="row">
                <span class="bold">
                  {{inventory_action_product.amount * getSelectedProduct(inventory_action_product.product_id)?.quantity | money}}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
    <div class="card product">
      <div class="card-content">
        <div class="card-details">
          <div class="row">
            <span class="light">Subtotal: {{ Subtotal | money }}</span>
          </div>
          <div class="row">
            <span class="light">IVA: {{ IVA | money }}</span>
          </div>
          <div class="row">
            <span class="bold">Total: {{ Total | money }}</span>
          </div>
        </div>
      </div>
    </div>
</div>